import Embedded from "@/Layouts/Embedded";
import {Head, Link, useForm, usePage} from "@inertiajs/inertia-react";
import ProductLogo from "@/Components/ProductLogo";
import React, {Fragment, useEffect, useState} from "react";
import styles from '@/../sass/embedded/components/Login.module.scss'
import {FormInput, PhoneOrEmailInput} from "@/Components/Controls";
import i18n from "i18next";
import Button from "@/Components/Button";
import AbstractLoginArtwork from "@/Components/AbstractLoginArtwork";

export default function Login() {
    const organization = usePage().props.organization;
    const preAuthorized = usePage().props?.embedded ?? false;

    const {data, setData, post } = useForm({
        email_or_phone: '',
        password: '',
    });

    const [state, setState] = useState({
        continueLogin: false,
        processing: false,
        flow: 'text',
        errors: []
    });

    useEffect(() => {
        if (preAuthorized) {
            window.parent.postMessage(JSON.stringify(preAuthorized), '*');
        }
    }, [preAuthorized]);

    useEffect(() => {
        let element = document.querySelector('[name=email_or_phone]').type
        if(element === 'tel') {
            setState({...state, flow: element})
        } else {
            setState({...state, flow: element})
        }
    }, [data.email_or_phone]);

    const onChange = (name, value) => {
        setData(name, value);
    };

    const submit = (e) => {
        e.preventDefault();

        setState({...state, processing: true})
        axios.post(
            route('embedded.login.store', organization.uuid),
            data
        ).then((response) => {
            window.parent.postMessage(JSON.stringify(response.data.data), '*')
        }).catch((error) => {
            setState({...state, errors: error?.response?.data?.errors, processing: false});
        })
    };

    const continueFlowControl = (e) => {
        e.preventDefault();
        setState({...state, processing: true});

        if(state.flow === 'tel') {
            axios.post(
                route('embedded.login.flow', organization.uuid), data)
                .then((response) => {
                    console.log(response.data.flow)
                    if(response.data.flow === 'code') {
                        post(route('embedded.login.code.request', organization.uuid),
                            {
                                onBefore: () => setState({...state, processing: true}),
                                onFinish: () => setState({...state, processing: false, continueLogin: false }),
                            });
                    } else {
                        setState({...state, continueLogin: true});
                    }
                }).catch((error) => {
                    setState({...state, errors: error?.response?.data?.errors, processing: false});
                })
        } else {
            setState({...state, continueLogin: true});
        }
    };

    return (
        <Embedded>
            <Head>
                <title>Login</title>
            </Head>
            <AbstractLoginArtwork/>
            <div className={"login"}>
                <ProductLogo />
                { preAuthorized && <div className={styles.preAuthorized}>
                    <span className="spinner-border spinner-border-lg" role="status" aria-hidden="true"></span>
                    <span className="visually-hidden">Loading...</span>
                </div>}
                {! preAuthorized && <form onSubmit={submit}>
                    <div className="row">
                        <PhoneOrEmailInput error={state.errors["email_or_phone"]}
                                           name="email_or_phone"
                                           isFocused={true}
                                           autoComplete="username"
                                           value={data.email_or_phone}
                                           onChange={onChange}
                                           label={i18n.t("login.email-or-phone")}
                                           className="col-12"
                                           dataQa="login-tab-choose-username"/>
                    </div>
                    {!state.continueLogin &&
                        <Fragment>
                            <Button
                                type="button"
                                processing={state.processing}
                                opacityWhileProcessing={false}
                                onClick={continueFlowControl}
                                className="w-100 btn btn-primary"
                            >
                                {state.processing && <Fragment>
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    <span className="visually-hidden">Loading...</span>
                                </Fragment>}
                                {!state.processing && i18n.t("login.continue")}
                            </Button>
                            <Fragment>
                                <div className={styles.or}>
                                    <hr/>
                                    <span>{i18n.t("login.or")}</span>
                                    <hr/>
                                </div>
                                <Link
                                    className="w-100 btn btn-outline-secondary"
                                    href={route('embedded.join.create-account.show', organization.uuid)}
                                >
                                    {i18n.t("login.create-account")}
                                </Link>
                            </Fragment>
                        </Fragment>
                    }
                    {state.continueLogin &&
                        <Fragment>
                            <div className="row">
                                <FormInput format="password"
                                           error={state.errors["password"]}
                                           name="password"
                                           isFocused={true}
                                           autoComplete="current-password"
                                           value={data.password}
                                           onChange={onChange}
                                           label={i18n.t("login.password")}
                                           className="col-12"
                                           dataQa="login-tab-password"/>
                            </div>
                            <div className="">
                                <Button className="w-100 btn btn-primary" processing={state.processing} opacityWhileProcessing={false}>
                                    {state.processing && <Fragment>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        <span className="visually-hidden">Loading...</span>
                                    </Fragment>}
                                    {!state.processing && i18n.t("login.log-in")}
                                </Button>
                            </div>
                        </Fragment>
                    }
                    <div className={"forgot-password-link"}>
                        <Link
                            href={route('embedded.password.request', organization.uuid)}
                            className="btn btn-link text-center"
                        >
                            {i18n.t("login.forgot-password")}
                        </Link>
                    </div>
                </form>}
            </div>
        </Embedded>
    )
}
